export const GOOGLE_MAPS_URL = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_API_KEY_MAP}&amp;v=3.exp&amp;libraries=places`;

export const partnerHosts = [process.env.REACT_APP_PARTNER_HOST];
export const reikatachiHosts = [process.env.REACT_APP_REIKATACHI_HOST];
export const APP_NAME = process.env.REACT_APP_APP_NAME || 'Reikatachi';
export const APP_LOGO = process.env.REACT_APP_APP_LOGO;